module.exports = __webpack_public_path__ + "static/img/07.29cd366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/07.jpg
// module id = 1MYR
// module chunks = 0